var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonAFY, ModalComponentAFY, SelectAFY, sizes, sizesSelect, typeAlert, variants, variantsTextField, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import * as catalogConst from "../../const/catalog";
import { STEP_CLIENTRECORD } from "../../const/catalog";
import { stepProgress } from "../../dataBase/stepProgress";
import { hasPermission } from "../../services/getNavigationPages";
import LocalStorageService from "../../services/localStorage";
import showToast from "../../services/toast";
import { quoteAll, quoteAllClearData } from "../../store/generateQuote/actions";
import { identificationType } from "../../store/identificationType/actions";
import { personById, personByIdClearData } from "../../store/person/actions";
import { policyCancelClearData } from "../../store/policy/actions";
import { cancelQuoteClearData } from "../../store/cancelQuote/actions";
import { formattedDate } from "../../utils/date";
import { GetCatalogsType } from "../../fnx/catalog/getCatalogsType";
import { getCatalogsTypeClearData } from "../../store/catalog/actions";
import { showErrorToast } from "../../fnx/showError";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { useTranslation } from "react-i18next";
import { beneficiaryColumns, Columns, insuredColumns, } from "./resources/clientRecordDTO";
import "./assets/style.css";
import { ClientRecordView } from "./ui/view";
import useSelectors from "./components/selectors";
import useUI from "./components/ui";
import useClientRecord from "./components/clientRecord";
import { ClientRecordHeader } from "./ui/header";
import { Modal } from "./ui/modals";
import PagesHeader from "ah_utility/PagesHeader";
import { useGetSteps } from "../../utils/getSteps";
import { getStepNavigation } from "../../utils/nextBackStep";
import { useGetSummary } from "../../utils/getSummary";
import { useGetInformationSteps } from "../../utils/getInformationStep";
import { useCompleteStep } from "../../utils/responseComplete";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var ClientRecordPage = function () {
    var STEP = STEP_CLIENTRECORD;
    var dispatch = useDispatch();
    var id = useParams().id;
    var _a = React.useState(true), enable = _a[0], setEnable = _a[1];
    var _b = React.useState(1), page = _b[0], setPage = _b[1];
    var company = React.useState(lsLogin.getUserLoginStored().subdomain || "")[0];
    var _c = React.useState(false), triggerPermissionList = _c[0], setTriggerPermissionList = _c[1];
    var _d = React.useState(5000), limit = _d[0], setLimit = _d[1];
    var loadingAllQuote = useState(false)[0];
    var _e = useState(false), showInfo = _e[0], setShowInfo = _e[1];
    var _f = useState([]), clientInfo = _f[0], setClientInfo = _f[1];
    var _g = useState([]), rowsQuote = _g[0], setRowsQuote = _g[1];
    var _h = useState(false), showBeneficiariesModal = _h[0], setShowBeneficiariesModal = _h[1];
    // const [steps, setSteps] = React.useState<MenuItem[]>([]);
    var _j = useState(false), showInsuredModal = _j[0], setShowInsuredModal = _j[1];
    var _k = useState([]), beneficiariesRows = _k[0], setBeneficiariesRows = _k[1];
    var _l = useState([]), insuredRows = _l[0], setInsuredRows = _l[1];
    var _m = useState(""), documentNumber = _m[0], setDocumentNumber = _m[1];
    var _o = useState(""), documentType = _o[0], setDocumentType = _o[1];
    var _p = useState([]), filters = _p[0], setFilters = _p[1];
    var _q = useState([]), filtersII = _q[0], setFiltersII = _q[1];
    var _r = React.useState([]), breadCrumbs = _r[0], setBreadCrumbs = _r[1];
    var _s = useState(true), showNextDisabled = _s[0], setShowNextDisabled = _s[1];
    var storageKeyVariables = "afy-variables";
    var lsVariables = new LocalStorageService(storageKeyVariables);
    var _t = useState(""), documentName = _t[0], setDocumentName = _t[1];
    var _u = useCompleteStep(), runComplete = _u.runComplete, loadingComplete = _u.loadingComplete, responseComplete = _u.responseComplete, errorComplete = _u.errorComplete;
    var _v = useState(false), openModalConfirm = _v[0], setOpenModalConfirm = _v[1];
    var _w = useState([]), reasonCancellation = _w[0], setReasonCancellation = _w[1];
    var _x = useState(""), policyId = _x[0], setPolicyId = _x[1];
    var _y = useState(true), type = _y[0], setType = _y[1]; //cotizacion = false o poliza = true
    var _z = useState("Póliza"), modalTitle = _z[0], setModalTitle = _z[1];
    var _0 = useState(false), triggerCatalogs = _0[0], setTriggerCatalogs = _0[1];
    var t = useTranslation().t;
    var _1 = useState(null), dataAddress = _1[0], setDataAddress = _1[1];
    var _2 = useState([]), listIdentificationType = _2[0], setListIdentificationType = _2[1];
    var _3 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _3[0], setSeeToast = _3[1];
    var permissions = {
        create: hasPermission("sale-record-client-view"),
    };
    var pathname = useLocation().pathname;
    var pathLocation = "/" + pathname.split("/")[1];
    var _4 = React.useState({}), sessionData = _4[0], setSessionData = _4[1];
    var _5 = React.useState(false), loading = _5[0], setLoading = _5[1];
    var storageKey = "afy-steps";
    var dataNavigation = React.useState(getStepNavigation(pathLocation))[0];
    var summary = useGetSummary();
    var _6 = useSelectors(), responsePerson = _6.responsePerson, errorPerson = _6.errorPerson, responseAllQuote = _6.responseAllQuote, responseIdentificationType = _6.responseIdentificationType, responseBeneficiary = _6.responseBeneficiary, responseInsured = _6.responseInsured, loadingPerson = _6.loadingPerson, loadingIdentificationType = _6.loadingIdentificationType, loadingBeneficiary = _6.loadingBeneficiary, responseCancelPolicy = _6.responseCancelPolicy, errorCancelPolicy = _6.errorCancelPolicy, loadingCancelPolicy = _6.loadingCancelPolicy, responseCancelQuote = _6.responseCancelQuote, errorCancelQuote = _6.errorCancelQuote, loadingCancelQuote = _6.loadingCancelQuote;
    var _7 = useClientRecord(setShowNextDisabled, setDocumentType, setDocumentName, setDocumentNumber, documentNumber, setSeeToast, typeAlert, listIdentificationType, lsVariables, documentType), handleChange = _7.handleChange, handleChangeSelect = _7.handleChangeSelect, handleSearch = _7.handleSearch, isValid = _7.isValid, validDocument = _7.validDocument;
    var _8 = useGetInformationSteps(pathLocation), instanceId = _8.instanceId, workFlowId = _8.workFlowId, currentStep = _8.currentStep, nextStep = _8.nextStep;
    var _9 = useUI(setShowBeneficiariesModal, setShowInsuredModal, id, STEP, isValid, setSeeToast, setOpenModalConfirm, setPolicyId, setType, setModalTitle, setTriggerCatalogs, instanceId || "", workFlowId || "", currentStep || "", nextStep || "", runComplete, sessionData, dataAddress), handleClickContextMenu = _9.handleClickContextMenu, handleClickNext = _9.handleClickNext, handleClickPrevious = _9.handleClickPrevious, handleCancelPolicy = _9.handleCancelPolicy, isNextDisabled = _9.isNextDisabled;
    var _10 = GetCatalogsType(triggerCatalogs, enable, page, limit, catalogConst.CATALOG_REASON_CANCELLATION), responseGetCatalogsType = _10.responseGetCatalogsType, loadingGetCatalogsType = _10.loadingGetCatalogsType, errorGetCatalogsType = _10.errorGetCatalogsType;
    // Handle cancel policy response
    useEffect(function () {
        console.log("Cancel policy useEffect triggered:", {
            responseCancelPolicy: !!responseCancelPolicy,
            responseCancelPolicyType: typeof responseCancelPolicy,
            responseCancelPolicyValue: responseCancelPolicy,
            documentNumber: documentNumber,
            clientId: responsePerson === null || responsePerson === void 0 ? void 0 : responsePerson.clientId,
            enable: enable,
            page: page,
            limit: limit,
        });
        if (responseCancelPolicy &&
            typeof responseCancelPolicy === "object" &&
            responseCancelPolicy !== true) {
            showToastSuccessMessage("Póliza cancelada exitosamente", typeAlert.success, setSeeToast);
            dispatch(policyCancelClearData());
            // Refresh the quotes list with current values
            var currentDocumentNumber = documentNumber;
            var currentClientId = responsePerson === null || responsePerson === void 0 ? void 0 : responsePerson.clientId;
            if (currentDocumentNumber && currentClientId) {
                console.log("Refreshing quotes with params:", {
                    clientId: currentClientId,
                    enable: enable,
                    page: page,
                    limit: limit,
                    numberId: currentDocumentNumber,
                    fields: "abc",
                });
                dispatch(quoteAll({
                    clientId: currentClientId,
                    enable: enable,
                    page: page,
                    limit: limit,
                    numberId: currentDocumentNumber,
                    fields: "abc",
                }));
            }
        }
    }, [responseCancelPolicy, dispatch]);
    // Handle cancel policy error
    useEffect(function () {
        if (errorCancelPolicy) {
            showErrorToast(errorCancelPolicy, setSeeToast, t);
            dispatch(policyCancelClearData());
        }
    }, [errorCancelPolicy, dispatch]);
    // Handle cancel quote response
    useEffect(function () {
        console.log("Cancel quote useEffect triggered:", {
            responseCancelQuote: !!responseCancelQuote,
            responseCancelQuoteType: typeof responseCancelQuote,
            responseCancelQuoteValue: responseCancelQuote,
            documentNumber: documentNumber,
            clientId: responsePerson === null || responsePerson === void 0 ? void 0 : responsePerson.clientId,
            enable: enable,
            page: page,
            limit: limit,
        });
        if (responseCancelQuote &&
            typeof responseCancelQuote === "object" &&
            responseCancelQuote !== true) {
            showToastSuccessMessage("Cotización cancelada exitosamente", typeAlert.success, setSeeToast);
            dispatch(cancelQuoteClearData());
            // Refresh the quotes list with current values
            var currentDocumentNumber = documentNumber;
            var currentClientId = responsePerson === null || responsePerson === void 0 ? void 0 : responsePerson.clientId;
            if (currentDocumentNumber && currentClientId) {
                console.log("Refreshing quotes after quote cancellation with params:", {
                    clientId: currentClientId,
                    enable: enable,
                    page: page,
                    limit: limit,
                    numberId: currentDocumentNumber,
                    fields: "abc",
                });
                dispatch(quoteAll({
                    clientId: currentClientId,
                    enable: enable,
                    page: page,
                    limit: limit,
                    numberId: currentDocumentNumber,
                    fields: "abc",
                }));
            }
        }
    }, [responseCancelQuote, dispatch]);
    // Handle cancel quote error
    useEffect(function () {
        if (errorCancelQuote) {
            showErrorToast(errorCancelQuote, setSeeToast, t);
            dispatch(cancelQuoteClearData());
        }
    }, [errorCancelQuote, dispatch]);
    // Handle catalogs response
    useEffect(function () {
        if (responseGetCatalogsType && Array.isArray(responseGetCatalogsType)) {
            var newArray = responseGetCatalogsType.map(function (item) { return ({
                id: item.id,
                value: item.id,
                name: item.description,
            }); });
            setReasonCancellation(newArray);
            dispatch(getCatalogsTypeClearData());
            setTriggerCatalogs(false);
        }
    }, [responseGetCatalogsType, dispatch]);
    var _11 = useState(""), selectedReasonCancellation = _11[0], setSelectedReasonCancellation = _11[1];
    var handleCloseModalConfirm = function () {
        setOpenModalConfirm(false);
        setTriggerCatalogs(false);
        setSelectedReasonCancellation("");
    };
    var handleSubmitCancelPolicy = function () {
        if (selectedReasonCancellation) {
            handleCancelPolicy(selectedReasonCancellation, type, policyId);
            // Close modal immediately after submitting
            setOpenModalConfirm(false);
            setTriggerCatalogs(false);
            setSelectedReasonCancellation("");
        }
    };
    var handleChangeCancellationReason = function (value) {
        setSelectedReasonCancellation(value);
    };
    useEffect(function () {
        dispatch(personByIdClearData());
        dispatch(quoteAllClearData());
        dispatch(identificationType({ enable: enable, page: page, limit: limit }));
        setBreadCrumbs(stepProgress(STEP, true));
        // setSteps(stepProgress(STEP));
        // Comes from the client page
        if (id) {
            setDocumentNumber(id);
            dispatch(
            //personById({ enable: enable, page: page, limit: limit, numberId: id }),
            personById(id));
        }
    }, []);
    useEffect(function () {
        var _a, _b;
        if (errorPerson) {
            if (((_b = (_a = errorPerson.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.code) === 404) {
                setShowInfo(false);
                setShowNextDisabled(validDocument(documentName, documentNumber) ? false : true);
                setSeeToast({
                    show: true,
                    message: "¡No se encontraron datos para la busqueda!",
                    type: typeAlert.info,
                });
            }
        }
    }, [errorPerson]);
    useEffect(function () {
        if (errorComplete) {
            setSeeToast({
                show: true,
                message: errorComplete.message,
                type: typeAlert.error,
            });
        }
    }, [errorComplete]);
    useEffect(function () {
        var _a;
        if (responsePerson) {
            setShowInfo(true);
            var addressData = {
                providence: responsePerson.catalogRegionLevel1,
                town: responsePerson.catalogRegionLevel2,
                sector: responsePerson.catalogRegionLevel3,
                address: responsePerson.addressA,
            };
            setDataAddress(addressData);
            // Actualizar sessionData con toda la estructura de datos
            setSessionData({
                additionalContentMap: (responsePerson === null || responsePerson === void 0 ? void 0 : responsePerson.additionalContentMap) || {},
                clientId: responsePerson.clientId,
                numberId: responsePerson.numberId,
                personData: responsePerson,
            });
            if (!((_a = responsePerson === null || responsePerson === void 0 ? void 0 : responsePerson.additionalContentMap) === null || _a === void 0 ? void 0 : _a.accounts)) {
                setSeeToast({
                    show: true,
                    message: "¡La persona no es cliente del banco!",
                    type: typeAlert.warning,
                });
            }
            dispatch(quoteAll({
                clientId: responsePerson.clientId,
                enable: enable,
                page: page,
                limit: limit,
                numberId: responsePerson.numberId,
                fields: "abc",
            }));
            setClientInfo([
                {
                    label: "Nombre completo",
                    value: responsePerson.lastNameA +
                        " " +
                        responsePerson.lastNameB +
                        ", " +
                        responsePerson.firstNameA +
                        " " +
                        responsePerson.firstNameB,
                },
                {
                    label: "Fecha de nacimiento",
                    value: formattedDate(responsePerson.dob),
                },
                {
                    label: "Identificación",
                    value: documentNumber ? documentNumber : responsePerson.numberId,
                },
                { label: "Teléfono casa", value: responsePerson.phone1 },
                { label: "Email", value: responsePerson.email },
                { label: "Dirección", value: responsePerson.addressA },
            ]);
        } /* else {
          if (responsePerson === null) {
            setShowInfo(false);
            setShowNextDisabled(true);
            setSeeToast({
              show: true,
              message: "¡No se encontraron datos para la busqueda!",
              type: typeAlert.info,
            });
          }
        } */
        if (id) {
            setShowNextDisabled(true);
        }
        else {
            setShowNextDisabled(validDocument(documentName, documentNumber) ? false : true);
        }
        dispatch(personByIdClearData());
    }, [responsePerson]);
    useEffect(function () {
        var _a;
        if (errorPerson) {
            if (((_a = errorPerson.errors[0]) === null || _a === void 0 ? void 0 : _a.code) === 404) {
                setShowInfo(false);
                setShowNextDisabled(validDocument(documentName, documentNumber) ? false : true);
                setSeeToast({
                    show: true,
                    message: "¡No se encontraron datos para la busqueda!",
                    type: typeAlert.info,
                });
            }
        }
    }, [errorPerson]);
    useEffect(function () {
        setRowsQuote([]);
        if (responseAllQuote && (responseAllQuote === null || responseAllQuote === void 0 ? void 0 : responseAllQuote.length) > 0) {
            var srq = [];
            responseAllQuote.map(function (item) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var prima = ((_a = item.lastPrice) === null || _a === void 0 ? void 0 : _a.currencySymbol) + " " + ((_b = item.lastPrice) === null || _b === void 0 ? void 0 : _b.amount);
                srq.push({
                    id: item.id,
                    estado: (_c = item.catalogStatusQuote) === null || _c === void 0 ? void 0 : _c.description,
                    cotizacion: item.code,
                    poliza: (_d = item.policyId) === null || _d === void 0 ? void 0 : _d.code,
                    producto: (_e = item.productId) === null || _e === void 0 ? void 0 : _e.description,
                    plan: (_f = item.planId) === null || _f === void 0 ? void 0 : _f.name,
                    policyId: (_g = item.policyId) === null || _g === void 0 ? void 0 : _g.id,
                    prima: prima,
                    productId: (_h = item.productId) === null || _h === void 0 ? void 0 : _h.id,
                });
            });
            setRowsQuote(srq);
        }
    }, [responseAllQuote]);
    useEffect(function () {
        if (showBeneficiariesModal && showInsuredModal) {
            setShowBeneficiariesModal(false);
            setShowInsuredModal(false);
        }
    }, [showBeneficiariesModal, showInsuredModal]);
    useEffect(function () {
        var _a;
        setInsuredRows([]);
        if (responseInsured && ((_a = responseInsured.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            responseInsured.data.map(function (item) {
                setInsuredRows(function (prev) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    return __spreadArray(__spreadArray([], prev, true), [
                        {
                            id: item.id,
                            type: (_a = item.catalogInsuredTypeInfo) === null || _a === void 0 ? void 0 : _a.description,
                            name: (_b = item.personInfo) === null || _b === void 0 ? void 0 : _b.firstNameA,
                            secondName: (_c = item.personInfo) === null || _c === void 0 ? void 0 : _c.firstNameB,
                            lastName: (_d = item.personInfo) === null || _d === void 0 ? void 0 : _d.lastNameA,
                            secondLastName: (_e = item.personInfo) === null || _e === void 0 ? void 0 : _e.lastNameB,
                            marriedName: (_f = item.personInfo) === null || _f === void 0 ? void 0 : _f.marriedName,
                            phone: (_g = item.personInfo) === null || _g === void 0 ? void 0 : _g.phone1,
                            email: (_h = item.personInfo) === null || _h === void 0 ? void 0 : _h.email,
                            dob: (_j = item.personInfo) === null || _j === void 0 ? void 0 : _j.dob,
                        },
                    ], false);
                });
            });
        }
    }, [responseInsured]);
    useEffect(function () {
        var _a;
        setBeneficiariesRows([]);
        if (responseBeneficiary && ((_a = responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            responseBeneficiary.data.map(function (item) {
                setBeneficiariesRows(function (prev) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    return __spreadArray(__spreadArray([], prev, true), [
                        {
                            id: item.id,
                            type: (_a = item.catalogBeneficiaryTypeInfo) === null || _a === void 0 ? void 0 : _a.description,
                            name: (_b = item.personInfo) === null || _b === void 0 ? void 0 : _b.firstNameA,
                            secondName: (_c = item.personInfo) === null || _c === void 0 ? void 0 : _c.firstNameB,
                            lastName: (_d = item.personInfo) === null || _d === void 0 ? void 0 : _d.lastNameA,
                            secondLastName: (_e = item.personInfo) === null || _e === void 0 ? void 0 : _e.lastNameB,
                            marriedName: (_f = item.personInfo) === null || _f === void 0 ? void 0 : _f.marriedName,
                            percentage: item.percentage,
                            phone: (_g = item.personInfo) === null || _g === void 0 ? void 0 : _g.phone1,
                            email: (_h = item.personInfo) === null || _h === void 0 ? void 0 : _h.email,
                            dob: (_j = item.personInfo) === null || _j === void 0 ? void 0 : _j.dob,
                        },
                    ], false);
                });
            });
        }
    }, [responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (responseIdentificationType === null || responseIdentificationType === void 0 ? void 0 : responseIdentificationType.data) {
            var data = (_a = responseIdentificationType.data) === null || _a === void 0 ? void 0 : _a.map(function (identification) {
                return {
                    id: identification.id,
                    value: identification.id,
                    name: identification.description,
                };
            });
            setListIdentificationType(data);
            setDocumentType((_c = (_b = data[0]) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : "");
            setDocumentName((_e = (_d = data[0]) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "");
        }
    }, [responseIdentificationType]);
    var handleClickSeeDetails = function (data) { };
    var steps = useGetSteps();
    useEffect(function () {
        var _a;
        var newMap = (_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.map(function (e) { return ({
            name: e.label,
            label: e.value,
            type: "label",
        }); });
        setFiltersII(newMap);
    }, [summary]);
    return (_jsxs(React.Fragment, { children: [_jsx(PagesHeader, { titlePage: "Registro de cliente", hideStep: false, steps: steps }), _jsx(ClientRecordHeader, { loading: loadingPerson ||
                    loadingIdentificationType ||
                    loadingAllQuote ||
                    loadingCancelPolicy ||
                    loadingCancelQuote, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, id: id, handleClickPrevious: handleClickPrevious }), _jsx(Modal, { title: "Beneficiarios", openModal: showBeneficiariesModal, columns: beneficiaryColumns, rows: beneficiariesRows, close: function () { return setShowBeneficiariesModal(false); } }), _jsx(Modal, { title: "Asegurados", openModal: showInsuredModal, columns: insuredColumns, rows: insuredRows, close: function () { return setShowInsuredModal(false); } }), _jsx(ModalComponentAFY, __assign({ openModal: openModalConfirm, backgroundColor: "#ffffff", onClose: handleCloseModalConfirm, border: 0, minWidthModal: "500px", padding: 40 }, { children: _jsxs("div", { children: [_jsxs("h2", __assign({ style: { textAlign: "center", marginBottom: "20px" } }, { children: ["Confirmaci\u00F3n para cancelar ", modalTitle] })), _jsxs("div", __assign({ style: { marginBottom: "20px" } }, { children: [_jsx("div", __assign({ style: { marginBottom: "10px", fontWeight: "bold" } }, { children: "Seleccione la raz\u00F3n de cancelaci\u00F3n:" })), _jsx(SelectAFY, { value: selectedReasonCancellation, variant: variantsTextField.filled, disableUnderline: true, fontSize: 14, size: sizesSelect.small, options: reasonCancellation, onChange: function (e) {
                                        e.stopPropagation();
                                        handleChangeCancellationReason(e.target.value);
                                    } })] })), _jsxs("div", __assign({ style: {
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "10px",
                            } }, { children: [_jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, label: "Cancelar", backgroundColor: "red", onClick: handleCloseModalConfirm }), _jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, label: "Confirmar", onClick: handleSubmitCancelPolicy, disabled: !selectedReasonCancellation })] }))] }) })), (listIdentificationType === null || listIdentificationType === void 0 ? void 0 : listIdentificationType.length) > 0 && (_jsx(ClientRecordView, { title: "Registro de cliente", hideFilter: !!id, breadcrumbs: breadCrumbs, stepProgress: steps, previousLabel: "Anterior", nextLabel: "Nueva cotización", nextDisabled: !isNextDisabled //|| (permissions.create ? !showNextDisabled : false)
                , showInfo: showInfo, showBeneficiariesModal: false, showInsuredModal: false, clientInfo: clientInfo, documentTypeList: listIdentificationType, rows: rowsQuote, filters: filtersII, columns: Columns(handleClickContextMenu), handleChange: handleChange, onClickSeeDetails: handleClickSeeDetails, onSearch: handleSearch, handleChangeSelect: handleChangeSelect, onClickNext: handleClickNext, onClickPrevious: handleClickPrevious }))] }));
};
